import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { ZonaService } from '../../_services/zona.service';
import { Zona } from '../../_models/zona';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { TerceroCargoService } from '../../_services/tercero-cargo.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { Table } from 'primeng/table';
import {TerceroZonaService} from "../../_services/tercero-zona.service";
import {TerceroZona} from "../../_models/tercero-zona";

@Component( {
  templateUrl: 'agenda-listado.component.html',
  selector: 'app-agenda',
} )
export class AgendaListadoComponent implements OnInit {

  formulario: FormGroup;
  columnas: any[];
  carBusqueda = false;
  estructurasFisicas: SelectItem[] = [];
  page = '0';
  rowsPerPage = 10;
  rowsCount = 10;
  zonas: Zona[] = [];
  menu: Funcionalidad = new Funcionalidad();
  objActulTerZona: TerceroZona[] = [];
  @ViewChild('dt', { static: true }) tabla: Table;

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private zonasServicio: ZonaService,
               private autServicio: AutenticacionService,
               private terCargosServicio: TerceroCargoService,
               private estructurasFisicasService: EstructuraFisicaService,
               private terZonasService: TerceroZonaService) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/agenda' );
    if ( mn ) {
      this.menu = mn;
    }

    this.formulario = this.formBuilder.group( {
      idEstructuraFisica: [ '', [] ],
      ejecutivo: [ '', [] ],
      zona: [ '', [] ],
    } );
    this.columnas = [
      { field: 'estructura', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_ESTRUCTURAFISICA' ), sort: false },
      { field: 'zona', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_ZONA' ), sort: false },
      { field: 'nombreEjecutivo', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_EJECUTIVO' ), sort: false },
      { field: 'indicadorPrincipal', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_PRINCIPAL' ), sort: false },
      { field: 'indicadorSecundario', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_SECUNDARIA' ), sort: false },
      { field: 'indicadorAgenda', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_INDICADORAGENDA' ), sort: false },
      { field: 'indicadorLibre', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_INDICADORLIBRE' ), sort: false },
      { field: 'indicadorSinRuta', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_INDICADORSINRUTA' ), sort: false },
      { field: 'indicadorLunes', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_LUNES' ), sort: false },
      { field: 'indicadorMartes', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_MARTES' ), sort: false },
      { field: 'indicadorMiercoles', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_MIERCOLES' ), sort: false },
      { field: 'indicadorJueves', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_JUEVES' ), sort: false },
      { field: 'indicadorViernes', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_VIERNES' ), sort: false },
      { field: 'indicadorSabado', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_SABADO' ), sort: false },
      { field: 'indicadorDomingo', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_DOMINGO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'SEGMENTOSPRODUCTOS.LBL_ACCIONES' ), sort: false },
    ];
    this.terCargosServicio.obtenerPorTercero( this.autServicio.obtenerUsuario().idTercero ).subscribe( terCargo => {
      const nivUsuario = this.autServicio.obtenerNivelMaximo();
      switch ( nivUsuario ) {
        case 1:
        case 2:
        case 3:
          if ( terCargo ) {
            this.estructurasFisicas.push( { label: terCargo.estructuraFisica, value: terCargo.idEstructuraFisica } );
          } else {
            this.navServicio.setMesage( 0,
              {
                severity: 'info',
                summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'MSG_FALTACONFIGURACION' )
              } );
          }
          break;
        case 4:
          if ( terCargo && terCargo.idAgrupacion ) {
            this.estructurasFisicasService.obtenerPorAgrupacion( terCargo.idAgrupacion ).subscribe( res2 => {
              res2.map( ( r: EstructuraFisica ) => {
                this.estructurasFisicas.push( { label: r.estructuraFisica, value: r.idEstructuraFisica } );
              } );
            } );
          } else {
            this.navServicio.setMesage( 0,
              {
                severity: 'info',
                summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'MSG_FALTACONFIGURACION' )
              } );
          }
          break;
        case 5:
          this.estructurasFisicasService.getAllEnabled().subscribe( res2 => {
            res2.map( ( r: EstructuraFisica ) => {
              this.estructurasFisicas.push( { label: r.estructuraFisica, value: r.idEstructuraFisica } );
            } );
          } );
          break;
        default:
          break;
      }
      this.getFilters();
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  filter( event?: any ): void {
    setTimeout( () => {
      this.carBusqueda = true;
    }, 80 );

    if ( event ) {
      this.page = String( event.first / this.rowsPerPage );
    } else {
      this.page = '0';
    }

    const a = new BusquedaFiltros();
    a.pagina = Number( this.page );
    a.cantidad = this.rowsPerPage;
    const forData = this.formulario.value;
    const objBusqueda = {
      idEstructuraFisica: forData.idEstructuraFisica ? forData.idEstructuraFisica : -1,
      ejecutivo: forData.ejecutivo ? forData.ejecutivo : '',
      zona: forData.zona ? forData.zona : ''
    };
    a.query = JSON.stringify( objBusqueda );


    this.navServicio.setFilters( 'agenda', 'idEstructuraFisica', this.f.idEstructuraFisica.value );
    this.navServicio.setFilters( 'agenda', 'ejecutivo', this.f.ejecutivo.value );
    this.navServicio.setFilters( 'agenda', 'zona', this.f.zona.value );

    this.zonasServicio.listadoZonasDias( a ).subscribe( rta => {
      this.rowsCount = Number( rta.total );
      rta.data.map( ( s: Zona ) => {
        s.indicadorSecundario = (s.indicadorPrincipal === false) ? true : false;
      } );
      this.zonas = rta.data;
      this.carBusqueda = false;
    }, e => {
      this.carBusqueda = false;
      this.navServicio.setMesage( 0,
        {
          severity: 'error',
          summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
          detail: this.navServicio.buscarMensaje( 'MSG_ERRORCARGAR' )
        } );

    } );
  }

  update( zona: Zona ): void {
    this.router.navigate( [ 'apl/agenda/asignar/' + zona.idZona ] );
  }

  view( zona: Zona ): void {
    this.router.navigate( [ 'apl/agenda/detalle/' + zona.idZona ] );
  }

  getFilters() {
    const filters = this.navServicio.getFilters( 'agenda' );
    if ( filters ) {
      filters.map( ( s: any ) => {
        if ( s.value ) {
          switch ( s.filter ) {
            case 'idEstructuraFisica': {
              this.f.idEstructuraFisica.setValue( s.value );
              break;
            }
            case 'ejecutivo': {
              this.f.ejecutivo.setValue( s.value );
              break;
            }
            case 'zona': {
              this.f.zona.setValue( s.value );
              break;
            }
            default: {
              break;
            }
          }
        }
      } );
    }
  }

  filterEnter() {
    if ( !this.carBusqueda ) {
      this.filter();
    }
  }

  limpiar() {
    this.formulario.reset();
    this.filter();
  }

  async cambiarProspectar( zona: Zona ) {
    this.carBusqueda = true;
    await this.zonasServicio.get( zona.idZona ).subscribe( zonActualizar => {
      zonActualizar.indicadorAgenda = zona.indicadorAgenda ? zona.indicadorAgenda : false;
      zonActualizar.indicadorLibre = zona.indicadorLibre ? zona.indicadorLibre : false;
      zonActualizar.indicadorSinRuta = zona.indicadorSinRuta ? zona.indicadorSinRuta : false;
       this.zonasServicio.update( zonActualizar ).subscribe( actualizado => {
        const a = this.zonas.findIndex( x => x.idZona === zona.idZona );
        if ( a >= 0 ) {
          this.zonas[ a ] = zona;
        }
        this.actualizaTerceroZona(zona)
        this.carBusqueda = false;
      } );
    } );


  }
 async actualizaTerceroZona(zonas : Zona){
     const terceroZona  = await this.terZonasService.obtenerPorZonas(zonas.idZona).toPromise();
    console.log(terceroZona);
    this.terZonasService.bulk( terceroZona ).subscribe();
  }


}
